// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"ab8aae22","563":"12e8cd98","787":"5cba2817"}[chunkId] + ".chunk.js";
};